module.exports = __webpack_public_path__ + "assets/img/box-active.d1aaefa3.png";